<template>
  <div class="box-detail projPackage">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/ProjPackages' })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>套餐管理</span>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="110px"
          @changeForm="osg.changeForm"
        ></c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="适用范围" name="scope">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="scopeSave">
                保存适用范围
              </el-button>
            </div>
          </div>
          <div class="box-center-content">
            <el-tree
              :data="scope.orgs"
              ref="scope"
              node-key="_id"
              :props="{ label: 'orgName', children: 'orgList' }"
              :expand-on-click-node="false"
              check-on-click-node
              show-checkbox
              default-expand-all
              :indent="50"
            ></el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane label="工序管理" name="Procedure">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openProcedure">
                添加工序
              </el-button>
            </div>
          </div>
          <div class="box-center-content settleTable">
            <el-table ref="addedProcedures" :data="procedure.addedFpi.data" border class="c-m-t-10">
              <el-table-column
                prop="procedure.content"
                label="服务内容"
                fixed
                width="150px"
              ></el-table-column>
              <el-table-column
                prop="procedure.guideUnitPrice"
                label="单价"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="procedure.minimumGuideTotalPrice"
                label="最低指导价"
                width="90"
              ></el-table-column>
              <el-table-column
                prop="procedure.unit"
                label="单位"
                width="80"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column
                prop="procedure.exts.repairPart"
                label="部位"
                width="200"
                :formatter="formatRepairPart"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="procedure.desc"
                label="服务描述"
                width="200px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column fixed="right" label="操作" width="150px">
                <template slot-scope="scope">
                  <el-button @click="procedureDelete(scope.row)" size="mini">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog
            title="添加工序"
            :visible.sync="procedure.open"
            custom-class="c-dialog c-min-height-80vh"
            @close="cancelProcedures"
          >
            <div class="c-flex c-flex-between c-flex-item">
              <div>
                <p v-if="procedure.selectedRows.length > 0">
                  已选中
                  <span class="c_blue">{{ procedure.selectedRows.length }}</span>
                  项
                </p>
              </div>
              <el-input
                class="search-input c-fr"
                placeholder="请输入工序服务内容"
                v-model="procedure.searchValue"
                clearable
                @clear="
                  selectProcedures();
                  procedure.notAddedFpi.page = 1;
                  getNotAddedProcedures();
                "
                @keyup.enter.native="
                  selectProcedures();
                  procedure.notAddedFpi.page = 1;
                  getNotAddedProcedures();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    selectProcedures();
                    procedure.notAddedFpi.page = 1;
                    getNotAddedProcedures();
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="notAddedTable"
              :data="procedure.notAddedFpi.data"
              empty-text="没有查询到工序"
              :row-key="getRowKey"
              @selection-change="selectProcedures"
              height="100px"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="服务内容"
                fixed
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                width="100"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column prop="guideUnitPrice" label="单价" width="100"></el-table-column>
              <el-table-column
                prop="minimumGuideTotalPrice"
                label="最低指导价"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="exts.repairPart"
                label="部位"
                width="200"
                :formatter="formatRepairPart"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="desc" label="服务描述" show-overflow-tooltip></el-table-column>
            </el-table>
            <div slot="footer" class="c-flex c-flex-between c-flex-item">
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="procedure.notAddedFpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="procedure.notAddedFpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="procedure.notAddedFpi.total"
              ></el-pagination>
              <div class="c-flex">
                <el-button type="primary" @click="addProcedures">确 定</el-button>
                <el-button @click="cancelProcedures">取 消</el-button>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="机措管理" name="Measure">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openMeasure">
                添加机措
              </el-button>
            </div>
          </div>
          <div class="box-center-content settleTable">
            <el-table ref="addedMeasures" :data="measure.addedFpi.data" border class="c-m-t-10">
              <el-table-column prop="measure.content" label="名称" fixed></el-table-column>
              <el-table-column
                prop="measure.unit"
                label="单位"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column prop="measure.guideUnitPrice" label="总部指导价"></el-table-column>
              <!-- <el-table-column
                prop="measure.minimumGuideTotalPrice"
                label="片区价格"
                width="150"
              ></el-table-column> -->
              <el-table-column
                prop="measure.desc"
                label="机措类型描述"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button @click="measureDelete(scope.row)" size="mini">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog
            title="添加机措"
            :visible.sync="measure.open"
            custom-class="c-dialog c-min-height-80vh"
            @close="cancelMeasures"
          >
            <div class="c-flex c-flex-between c-flex-item">
              <div>
                <p v-if="measure.selectedRows.length > 0">
                  已选中
                  <span class="c_blue">{{ measure.selectedRows.length }}</span>
                  项
                </p>
              </div>
              <el-input
                class="search-input c-fr"
                placeholder="请输入机措服务内容"
                v-model="measure.searchValue"
                clearable
                @clear="
                  selectMeasures();
                  measure.notAddedFpi.page = 1;
                  getNotAddedMeasures();
                "
                @keyup.enter.native="
                  selectMeasures();
                  measure.notAddedFpi.page = 1;
                  getNotAddedMeasures();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    selectMeasures();
                    measure.notAddedFpi.page = 1;
                    getNotAddedMeasures();
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="notAddedTable"
              :data="measure.notAddedFpi.data"
              empty-text="没有查询到机措"
              :row-key="getRowKey"
              @selection-change="selectMeasures"
              height="100px"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="服务内容"
                fixed
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                width="100"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column prop="guideUnitPrice" label="单价" width="100"></el-table-column>
              <!-- <el-table-column
                prop="minimumGuideTotalPrice"
                label="最低指导价"
                width="100"
              ></el-table-column> -->
              <!-- <el-table-column
                prop="repairPart"
                label="部位"
                width="100"
                :formatter="formatRepairPart"
              ></el-table-column> -->
              <el-table-column prop="desc" label="服务描述"></el-table-column>
            </el-table>
            <div slot="footer" class="c-flex c-flex-between c-flex-item">
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="measure.notAddedFpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="measure.notAddedFpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="measure.notAddedFpi.total"
              ></el-pagination>
              <div class="c-flex">
                <el-button type="primary" @click="addMeasures">确 定</el-button>
                <el-button @click="cancelMeasures">取 消</el-button>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="材料管理" name="Material">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openMaterial">
                添加材料
              </el-button>
            </div>
          </div>
          <div class="box-center-content settleTable">
            <el-table ref="addedMaterials" :data="material.addedFpi.data" border class="c-m-t-10">
              <el-table-column
                prop="material.name"
                label="材料名称"
                fixed
                width="150px"
              ></el-table-column>
              <el-table-column
                prop="material.type"
                label="材料类型"
                width="100"
                :formatter="formatType"
              ></el-table-column>
              <el-table-column prop="material.code" label="编号" width="100"></el-table-column>
              <el-table-column prop="material.spec" label="规格" width="100"></el-table-column>
              <el-table-column prop="material.model" label="型号" width="100"></el-table-column>
              <el-table-column
                prop="material.materialUnit"
                label="单位"
                width="100"
                :formatter="formatMaterialUnit"
              ></el-table-column>
              <el-table-column prop="material.price" label="单价" width="100"></el-table-column>
              <el-table-column label="材料消耗量" width="120">
                <template slot-scope="scope">
                  <template v-if="scope.row.editable">
                    <el-input-number
                      v-model="scope.row.coefficient"
                      :min="0"
                      :controls="false"
                      :precision="2"
                      style="width:100%;box-sizing:border-box;"
                    ></el-input-number>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.coefficient }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="消耗系数单位" width="100">
                <template slot-scope="scope">
                  <template v-if="scope.row.editable">
                    <el-select v-model="scope.row.coefficientUnit" placeholder="请选择">
                      <el-option
                        v-for="item in coefficientUnit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.coefficientUnit }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="150px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.editable"
                    @click="materialSave(scope.row)"
                    size="mini"
                    type="success"
                  >
                    保存
                  </el-button>
                  <el-button v-else @click="materialEdit(scope.row)" size="mini">
                    编辑
                  </el-button>
                  <el-button @click="materialDelete(scope.row)" size="mini">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog
            title="添加材料"
            :visible.sync="material.open"
            custom-class="c-dialog c-min-height-80vh"
            @close="cancelMaterials"
          >
            <div class="c-flex c-flex-between c-flex-item">
              <div>
                <p v-if="material.selectedRows.length > 0">
                  已选中
                  <span class="c_blue">{{ material.selectedRows.length }}</span>
                  项
                </p>
              </div>
              <el-input
                class="search-input c-fr"
                placeholder="请输入材料名称"
                v-model="material.searchValue"
                clearable
                @clear="
                  selectMaterials();
                  material.notAddedFpi.page = 1;
                  getNotAddedMaterials();
                "
                @keyup.enter.native="
                  selectMaterials();
                  material.notAddedFpi.page = 1;
                  getNotAddedMaterials();
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    selectMaterials();
                    material.notAddedFpi.page = 1;
                    getNotAddedMaterials();
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="notAddedTable"
              :data="material.notAddedFpi.data"
              empty-text="没有查询到材料"
              :row-key="getRowKey"
              @selection-change="selectMaterials"
              height="100px"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="材料名称"
                fixed
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="type"
                label="材料类型"
                width="100"
                :formatter="formatType"
              ></el-table-column>
              <el-table-column prop="code" label="编号" width="100"></el-table-column>
              <el-table-column prop="spec" label="规格" width="100"></el-table-column>
              <el-table-column prop="model" label="型号" width="100"></el-table-column>
              <el-table-column
                prop="materialUnit"
                label="单位"
                width="100"
                :formatter="formatMaterialUnit"
              ></el-table-column>
              <el-table-column prop="price" label="单价" width="100"></el-table-column>
            </el-table>
            <div slot="footer" class="c-flex c-flex-between c-flex-item">
              <el-pagination
                class="pagination"
                @size-change="pageSizeChangeMaterial"
                @current-change="pageChangeMaterial"
                :current-page="material.notAddedFpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="material.notAddedFpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="material.notAddedFpi.total"
              ></el-pagination>
              <div class="c-flex">
                <el-button type="primary" @click="addMaterials">确 定</el-button>
                <el-button @click="cancelMaterials">取 消</el-button>
              </div>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="综合页面" name="Comprehensive ">
          <div class="box-center-content settleTable">
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>工序管理</span>
            </div>
            <el-table ref="addedProcedures" :data="procedure.addedFpi.data" border class="c-m-t-10">
              <el-table-column prop="procedure.content" label="服务内容" fixed></el-table-column>
              <el-table-column prop="procedure.guideUnitPrice" label="单价"></el-table-column>
              <el-table-column
                prop="procedure.minimumGuideTotalPrice"
                label="最低指导价"
                width="90"
              ></el-table-column>
              <el-table-column
                prop="procedure.unit"
                label="单位"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column
                prop="procedure.exts.repairPart"
                label="部位"
                :formatter="formatRepairPart"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="procedure.desc"
                label="服务描述"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>机措管理</span>
            </div>
            <el-table ref="addedMeasures" :data="measure.addedFpi.data" border class="c-m-t-10">
              <el-table-column prop="measure.content" label="名称" fixed></el-table-column>
              <el-table-column
                prop="measure.unit"
                label="单位"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column prop="measure.guideUnitPrice" label="总部指导价"></el-table-column>
              <!-- <el-table-column
                prop="measure.minimumGuideTotalPrice"
                label="片区价格"
              ></el-table-column> -->
              <el-table-column
                prop="measure.desc"
                label="机措类型描述"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>材料管理</span>
            </div>
            <el-table ref="addedMaterialsx" :data="material.addedFpi.data" border class="c-m-t-10">
              <el-table-column prop="material.name" label="材料名称" fixed></el-table-column>
              <el-table-column
                prop="material.type"
                label="材料类型"
                :formatter="formatType"
              ></el-table-column>
              <el-table-column prop="material.code" label="编号"></el-table-column>
              <el-table-column prop="material.spec" label="规格"></el-table-column>
              <el-table-column prop="material.model" label="型号"></el-table-column>
              <el-table-column
                prop="material.materialUnit"
                label="单位"
                :formatter="formatMaterialUnit"
              ></el-table-column>
              <el-table-column prop="material.price" label="单价"></el-table-column>
              <el-table-column label="材料消耗量">
                <template slot-scope="scope">
                  <template v-if="scope.row.editable">
                    <el-input-number
                      v-model="scope.row.coefficient"
                      :min="0"
                      :controls="false"
                      :precision="2"
                      style="width:100%;box-sizing:border-box;"
                    ></el-input-number>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.coefficient }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="消耗系数单位">
                <template slot-scope="scope">
                  <template v-if="scope.row.editable">
                    <el-select v-model="scope.row.coefficientUnit" placeholder="请选择">
                      <el-option
                        v-for="item in coefficientUnit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.coefficientUnit }}</span>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="业务动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'projPackage',
  data() {
    window.$this = this;
    return {
      id: null,
      tenantId: '',
      loginOrgId: '',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_auditStatus: { codeId: 'auditStatus' },
        cascadeCode_repairParts: { codeId: 'repairParts' },
        codecfg_unit: { codeId: 'company' },
        codecfg_type: { codeId: 'type1' },
        codecfg_materialUnit: { codeId: 'company' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      rules: this.$util.rules,
      activeTab: 'scope',
      scope: {
        open: false,
        orgs: []
      },
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      price: {
        fpi: { pages: 1, rows: 10, data: [] },
        formData: {},
        open: false,
        searchValue: '',
        selectedRows: []
      },
      // 工序关联
      procedure: {
        open: false,
        addedFpi: {
          data: []
        },
        notAddedFpi: {
          data: []
        },
        searchValue: '', //未添加工序列表搜索值
        selectedRows: []
      },
      // 材料关联
      material: {
        open: false,
        addedFpi: {
          data: []
        },
        notAddedFpi: {
          data: []
        },
        searchValue: '', //未添加材料列表搜索值
        selectedRows: []
      },
      // coefficientUnit: '', //消耗系数单位
      // 机措关联
      measure: {
        open: false,
        coefficient: 0, //消耗系数
        addedFpi: {
          data: []
        },
        notAddedFpi: {
          data: []
        },
        searchValue: '', //未添加材料列表搜索值
        selectedRows: []
      },
      //消耗系数单位
      coefficientUnit: [
        {
          value: '公斤/平米',
          lable: '选项1'
        },
        {
          value: '平米/平米',
          lable: '选项2'
        },
        {
          value: 'ML/米',
          lable: '选项3'
        },
        {
          value: 'ML/平方米',
          lable: '选项4'
        }
      ],
      value: ''
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    // 获取当前租户id和登录人组织id
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;
    this.doInit();

    this.osg.getFields('projPackage', () => {
      this.getData(() => {
        this.getOrgs(() => {
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
        });
      });
    });
  },
  methods: {
    // formatCascadeMultiple(option, array) {
    //   if (!array) return;
    //   let string = '';
    //   // 多选级联 有几个循环几次
    //   for (let arr of array) {
    //     let str = '';
    //     let opts = this.$util.deepCopy(this.options[option]);
    //     //有几级循环几次
    //     for (let i = 0; i < arr.length; i++) {
    //       for (let opt of opts) {
    //         if (opt.value == arr[i]) {
    //           str += (opt.label || opt.name) + '/';
    //           opts = this.$util.deepCopy(opt.children);
    //           break;
    //         }
    //       }
    //     }
    //     string += str.slice(0, str.length - 1) + '、';
    //   }

    //   return string.slice(0, string.length - 1);
    // },
    formatApproveState(row, column, cellValue) {
      return this.osg.codelabel('auditStatus', cellValue);
    },
    formatRepairPart(row, column, cellValue) {
      return this.osg.formatCascadeMultiple('repairParts', cellValue);
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatMaterialUnit(row, column, cellValue) {
      return this.osg.codelabel('materialUnit', cellValue);
    },
    pageSizeChange(pageSize) {
      if (this.procedure.open) {
        this.procedure.notAddedFpi.rows = pageSize;
        this.getNotAddedProcedures();
      } else {
        this.material.notAddedFpi.rows = pageSize;
        this.getMaterials();
      }
    },
    pageSizeChangeMaterial(pageSize) {
      if (this.material.open) {
        this.material.notAddedFpi.rows = pageSize;
        this.getMaterial();
      }
    },
    pageChange(currentPage) {
      if (this.procedure.open) {
        this.procedure.notAddedFpi.page = currentPage;
        this.getNotAddedProcedures();
      } else {
        this.material.notAddedFpi.page = currentPage;
        this.getMaterials();
      }
    },
    pageChangeMaterial(currentPage) {
      if (this.material.open) {
        this.material.notAddedFpi.page = currentPage;
        this.getMaterial();
      }
    },
    getData(callback) {
      this.osg.ajax(
        `biz/projPackage/findById/${this.id}.do`,
        {},
        res => {
          res.entity.exts = res.entity.exts || {};
          let formData = res.entity;
          this.$util.renderExtField(this.extFields, formData);
          this.formData = formData;
          this.procedure.addedFpi = { data: formData.procedureList };
          this.measure.addedFpi = { data: formData.measureList };
          this.material.addedFpi = { data: formData.materialList };
          if (callback) callback(res);
        },
        {
          noload: true
        }
      );
    },

    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);

        // 超级管理员、平台管理员、当前组织都可以看到此条数据
        params.scopeIds = params.scopeIds || [];
        // if (params.scopeIds.indexOf('0') == -1) params.scopeIds.push('0');
        // if (params.scopeIds.indexOf(this.tenantId) == -1) params.scopeIds.push(this.tenantId);
        // if (params.scopeIds.indexOf(this.loginOrgId) == -1) params.scopeIds.push(this.loginOrgId);

        this.$util.saveExtField(this.extFields, params);
        this.osg.ajax(
          'biz/projPackage/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },

    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'projPackage',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    // 点击标签栏
    tabClick(tab) {
      switch (tab.name) {
        case 'scope':
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
          break;
        case 'Procedure':
          break;
        case 'Material':
          break;
        case 'Measure':
          break;
        case 'log':
          this.getLog();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
      }
    },
    /**
     * 适用范围
     */
    getOrgs(callback) {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          res.data.orgName = '全部组织';
          this.scope.orgs = [res.data];
          if (callback) callback();
        }
      );
    },
    scopeSave() {
      this.formData.scopeJson = this.$refs.scope.getCheckedKeys(true); // true:仅返回全选中的叶子节点的keys false:返回所有全选中的节点
      let scopeIds = this.$refs.scope.getCheckedKeys();
      if (!scopeIds.length == 0) {
        // .concat(this.$refs.scope.getHalfCheckedKeys());
        // if(scopeIds.indexOf('0') == -1)scopeIds.push('0');
        this.formData.scopeIds = scopeIds;
      } else {
        this.formData.scopeIds = [this.tenantId];
      }
      this.doSave();
    },
    getPrice() {
      let params = {
        page: this.price.fpi.page,
        rows: this.price.fpi.rows,
        'is:projPackageId|string#and': this.formData._id,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      this.osg.ajax('biz/projPackage/body/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.price.fpi = res;
        this.$nextTick(() => {
          this.$refs.price.doLayout();
          this.$forceUpdate();
        });
      });
    },
    priceSave() {
      if (this.osg.validate('priceFormData')) {
        let params = this.price.formData;
        params.projPackageId = this.formData._id;
        params.approveState = 0; //修改数据时审核状态改为0
        this.osg.ajax(
          'biz/projPackage/body/upsert.do',
          params,
          () => {
            this.osg.toast('保存成功！');
            this.price.open = false;
            this.price.formData = {};
            this.doInit();
            this.getPrice();
          },
          {
            noload: true
          }
        );
      }
    },
    doInit() {
      // this.formData = {scopeIds:[], exts: {} };
      this.price.open = false;
      //  this.price.open = true;
      // this.$util.renderExtField(this.extFields, this.formData);
    },
    openPrice() {
      this.price.formData = this.$util.deepCopy();
      this.price.open = true;
    },
    priceEdit(row) {
      this.price.formData = this.$util.deepCopy(row);
      this.price.open = true;
    },
    priceDelete(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/projPackage/remove/body/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getPrice();
        });
      });
    },

    /*工序管理*/
    //点击添加工序按钮
    openProcedure() {
      this.procedure.open = true;
      if (this.$refs.notAddedTable) this.$refs.notAddedTable.clearSelection();
      this.procedure.selectedRows = [];
      this.getNotAddedProcedures();
    },
    // 查询未添加工序
    getNotAddedProcedures() {
      let procedures = this.formData.procedureList || [];
      // 整理已添加材料的id 用作排除
      let ids = [];
      for (let procedure of procedures) {
        ids.push(procedure.procedureId);
      }
      let params = {
        page: this.procedure.notAddedFpi.page,
        rows: this.procedure.notAddedFpi.rows,
        'is:state|integer#and': 1,
        'is:approveState|integer#and': 1,
        'nin:_id|array#and': ids.join(), // 不查询已添加过的工序
        'regex:content|string#or': this.procedure.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('biz/procedure/query.do', params, res => {
        res.data.map(
          item => {
            item.editable = false;
            item.laborFee = 0;
            item.laborCost = 0;
          },
          {
            noload: true
          }
        );
        this.procedure.notAddedFpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.notAddedTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    getRowKey(row) {
      return row._id;
    },
    // 选择工序
    selectProcedures(rows) {
      this.procedure.selectedRows = rows || [];
    },
    // 添加选中的1个或多个工序
    addProcedures() {
      if (this.procedure.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      let data = [];
      for (let procedure of this.procedure.selectedRows) {
        data.push({
          projPackageId: this.formData._id,
          procedureId: procedure._id
        });
      }
      this.formData.procedureList = this.formData.procedureList.concat(data);
      this.cancelProcedures();
      this.doSave();
    },
    // 关闭添加工序弹窗 并取消已选中工序
    cancelProcedures() {
      this.procedure.open = false;
      this.procedure.searchValue = '';
      this.selectProcedures();
    },
    // 移除已添加的单个工序编辑的内容
    procedureDelete(row) {
      row.state = -1;
      this.doSave();
    },

    /*机措*/
    //点击添加机措按钮
    openMeasure() {
      this.measure.open = true;
      if (this.$refs.notAddedTable) this.$refs.notAddedTable.clearSelection();
      this.measure.selectedRows = [];
      this.getNotAddedMeasures();
    },
    // 查询未添加机措
    getNotAddedMeasures() {
      let measures = this.formData.measureList || [];
      // 整理已添加材料的id 用作排除
      let ids = [];
      for (let measure of measures) {
        ids.push(measure.measureId);
      }
      let params = {
        page: this.measure.notAddedFpi.page,
        rows: this.measure.notAddedFpi.rows,
        'is:state|integer#and': 1,
        'is:approveState|integer#and': 1,
        'nin:_id|array#and': ids.join(), // 不查询已添加过的工序
        'regex:content|string#or': this.measure.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('biz/measure/query.do', params, res => {
        res.data.map(
          item => {
            item.editable = false;
            item.laborFee = 0;
            item.laborCost = 0;
          },
          {
            noload: true
          }
        );
        this.measure.notAddedFpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.notAddedTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择机措
    selectMeasures(rows) {
      this.measure.selectedRows = rows || [];
    },
    // 添加选中的1个或多个机措
    addMeasures() {
      if (this.measure.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      let data = [];
      for (let measure of this.measure.selectedRows) {
        data.push({
          projPackageId: this.formData._id,
          measureId: measure._id
        });
      }
      this.formData.measureList = this.formData.measureList.concat(data);
      this.cancelMeasures();
      this.doSave();
    },
    // 关闭添加机措弹窗 并取消已选中机措
    cancelMeasures() {
      this.measure.open = false;
      this.measure.searchValue = '';
      this.selectMeasures();
    },

    // 移除已添加的单个机措编辑的内容
    measureDelete(row) {
      row.state = -1;
      this.doSave();
    },

    /*材料管理*/
    /*材料管理*/
    //点击添加材料按钮
    openMaterial() {
      this.material.open = true;
      if (this.$refs.notAddedTable) this.$refs.notAddedTable.clearSelection();
      this.material.selectedRows = [];
      this.getNotAddedMaterials();
    },
    // 查询未添加材料
    getNotAddedMaterials() {
      let materials = this.formData.materialList || [];
      // 整理已添加材料的id 用作排除
      let ids = [];
      for (let material of materials) {
        ids.push(material.materialId);
      }
      let params = {
        page: this.material.notAddedFpi.page,
        rows: this.material.notAddedFpi.rows,
        'is:state|integer#and': 1,
        'is:approveState|integer#and': 1,
        'nin:_id|array#and': ids.join(), // 不查询已添加过的材料
        'regex:name|string#or': this.material.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('basic/material/query.do', params, res => {
        res.data.map(
          item => {
            item.editable = false;
            // item.coefficient = 0;
          },
          {
            noload: true
          }
        );
        this.material.notAddedFpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.notAddedTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // getRowKey(row) {
    //   return row._id;
    // },
    // 选择材料
    selectMaterials(rows) {
      this.material.selectedRows = rows || [];
    },
    // 添加选中的1个或多个材料
    addMaterials() {
      if (this.material.selectedRows.length == 0) {
        this.osg.toast('请选择至少1项！', 'warning');
        return;
      }
      let data = [];
      for (let material of this.material.selectedRows) {
        // item.coefficient = 0;
        data.push({
          projPackageId: this.formData._id,
          materialId: material._id
        });
      }
      this.formData.materialList = this.formData.materialList.concat(data);
      this.cancelMaterials();
      this.doSave();
    },
    // 关闭添加材料弹窗 并取消已选中材料
    cancelMaterials() {
      this.material.open = false;
      this.material.searchValue = '';
      this.selectMaterials();
    },
    // 移除已添加的单个材料编辑的内容
    materialDelete(row) {
      row.state = -1;
      this.doSave();
    },
    // 点击编辑已添加的单个材料
    materialEdit(row) {
      row.editable = true;
      this.$refs.addedMaterials && this.$refs.addedMaterials.doLayout();
    },
    // 保存已添加的单个材料编辑的内容
    materialSave(row) {
      row.editable = false;
      this.doSave();
    },
    //审核
    priceaudit(approveState) {
      /**
       * auditStatus
       * 0:待审核（新建后是自由态-->审核状态设为0:待审核）
       * 1:审核通过（平台点审核通过-->审核状态改为1:审核通过）
       * 2:审核不通过（平台点审核通过-->审核状态改为2:审核不通过）
       */
      // 至少选择一个产品
      if (this.price.selectedRows.length == 0) {
        this.osg.toast('请至少勾选一条待审核的数据', 'warning');
        return;
      }
      // 判断选择的产品状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (approveState) {
        case '1':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '2':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        default:
      }
      this.osg.confirm(`是否确认“${confirmMsg}”？`, () => {
        this.auditConfirm(approveState, msg);
      });
    },
    auditConfirm(approveState, msg) {
      let ids = [];
      this.price.selectedRows.map(item => {
        ids.push(item._id);
      }),
        this.osg.ajax(
          'biz/projPackage/approve/body.do',
          {
            ids: ids.join(),
            approveState: approveState
            // data: JSON.stringify({
            //   datas: this.price.selectedRows,
            //   newAuditStatus: approveState,
            //   // remark: this.auditObj.remark || null
            // })
          },
          () => {
            this.osg.toast(msg);
            // this.auditObj.remark = '';
            // this.auditObj.show = false;
            this.getPrice();
          }
        );
    }
  }
};
</script>
<style lang="scss">
.projPackage {
  .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
      .box-center-content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
.projPackage .c-dialog {
  min-width: 1000px !important;
}
.c-min-height-80vh {
  min-height: 80vh;
}
.projPackage .c-dialog.c-min-width-600 {
  min-width: 600px !important;
}
.c-radio-group {
  display: flex !important;
}
</style>
